import * as React from 'react';
import { Tabs as MuiTabs, TabsProps } from '@mui/material';
import { tabStylesContained } from 'ui/Tabs/tabsStyles';

interface Props extends TabsProps {
  /* renders a bottom border when true */
  contained?: boolean;
}
/**
 * A styled Tabs component. The contained prop will render a bottom border
 * [Material ui Tabs](https://mui.com/api/tabs/)
 *
 * ```js
 * import { Tabs } from 'ui';
 * ```
 *
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Tabs: React.FunctionComponent<React.PropsWithChildren<Props>> = (props) => {
  const { children, className, contained, ...rest } = props;
  return (
    <MuiTabs
      {...rest}
      className={className}
      {...(contained ? { css: tabStylesContained } : null)}
      TabIndicatorProps={{
        style: { height: 3 },
      }}
      indicatorColor="primary"
    >
      {children}
    </MuiTabs>
  );
};
export default Tabs;
